module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": _vm.columns,
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Image Upload")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showUploader = 'hero', _vm.columns = '1fr'
      }
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showUploader = 'bacteria', _vm.columns = '1fr 1fr'
      }
    }
  }, [_vm._v("Lifestyle Widget")])]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', [_c('div', {
    staticClass: "input-box flex center-flex-y bacteria-image-upload"
  }, [_c('input', {
    ref: "fileUpload",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.processPreviewImage($event, 'hero'), _vm.showPreview = true
      }
    }
  }), _vm._v(" "), (_vm.heroImage) ? _c('div', {
    staticClass: "upload-preview",
    on: {
      "click": function($event) {
        [_vm.heroImage = '', _vm.clearUploader(), _vm.showPreview = false]
      }
    }
  }, [_c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.heroImage
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("Uploader does not actually upload")]), _vm._v(" "), _c('h4', [_vm._v("Hero Text")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heroText),
      expression: "heroText"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hero Text"
    },
    domProps: {
      "value": (_vm.heroText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heroText = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showUploader === 'bacteria') ? _c('div', {
    staticClass: "bacteria-image"
  }, [_c('div', {
    staticClass: "input-box flex center-flex-y bacteria-image-upload"
  }, [_c('input', {
    ref: "fileUpload",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.processPreviewImage($event, 'bacteria')
      }
    }
  }), _vm._v(" "), (_vm.previewImage) ? _c('div', {
    staticClass: "upload-preview",
    on: {
      "click": function($event) {
        [_vm.previewImage = '', _vm.clearUploader()]
      }
    }
  }, [_c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.previewImage
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v("Uploader does not actually upload")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Image Preview")]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', {
    staticClass: "hero-preview"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('mobile')
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('desktop')
      }
    }
  }, [_vm._v("Desktop")])]), _vm._v(" "), (_vm.showPreview) ? _c('div', {
    staticClass: "desktop-preview"
  }, [_c('div', {
    ref: "hero",
    staticClass: "hero-image desktop"
  }, [_c('img', {
    staticClass: "object-fit",
    attrs: {
      "src": _vm.heroImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h2', {
    staticClass: "hero-text-title"
  }, [_vm._v(_vm._s(_vm.heroText))]), _vm._v(" "), _c('span', {
    staticClass: "hero-author"
  }, [_c('i', [_vm._v("by")]), _vm._v("\n              Boaty McBoatface\n            ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showUploader === 'bacteria' && _vm.previewImage) ? _c('div', {
    staticClass: "image-bg flex center-flex"
  }, [(_vm.previewImage) ? _c('img', {
    staticClass: "lazyload-images",
    attrs: {
      "src": _vm.previewImage
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1006e970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/images.vue
// module id = 626
// module chunks = 1